import { render, staticRenderFns } from "./tradecardform.vue?vue&type=template&id=2045aaee&scoped=true&"
import script from "./tradecardform.vue?vue&type=script&lang=js&"
export * from "./tradecardform.vue?vue&type=script&lang=js&"
import style0 from "./tradecardform.vue?vue&type=style&index=0&id=2045aaee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2045aaee",
  null
  
)

export default component.exports